import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import Error from '@components/Error/Error'
import PageHeading from '@components/PageHeading/PageHeading'
import Pagination from '@components/Pagination/Pagination'
import Search from '@components/pages/MiscellaneousTax/Search'
import Table from '@components/pages/MiscellaneousTax/ListTable'
import GET_MISCELLANEOUS_TAXES from '@graphql/queries/get-miscellaneous-taxes'

function List() {
  const [searchParams, setSearchParams] = useSearchParams()
  const searchFilters = Object.fromEntries(searchParams)
  const { data, loading, error, refetch } = useQuery(GET_MISCELLANEOUS_TAXES, {
    variables: { filters: searchFilters }
  })

  return (
    <>
      <PageHeading heading='Miscellaneous Taxes' />

      {error ? (
        <Error error={error} />
      ) : (
        <>
          <Search
            refetch={refetch}
            searchFilters={searchFilters}
            setSearchParams={setSearchParams}
          />
          <Pagination
            onPageChange={(page) => setSearchParams({ ...searchFilters, page })}
            pageMetadata={data?.miscellaneousTaxes?.metadata}
          />
          <Table
            totalCount={data?.miscellaneousTaxes?.metadata?.totalCount}
            miscellaneousTaxes={data?.miscellaneousTaxes?.collection || []}
            loading={loading}
          />
          <Pagination
            onPageChange={(page) => setSearchParams({ ...searchFilters, page })}
            pageMetadata={data?.miscellaneousTaxes?.metadata}
          />
        </>
      )}
    </>
  )
}

export default List
